'use client';

import type { Team } from '@/services/teams.service';
import { useUserDataContext } from './contexts/user-data-context';
import { TeamSwitcher } from './team-switcher';

export function WorkspaceHeader() {
  const { userTeams } = useUserDataContext();

  if (!userTeams.some((team: Team) => team.status === 'active')) return null;

  return (
    <header
      aria-label="Team selection"
      className="flex shrink-0 flex-wrap items-center justify-end gap-x-6 gap-y-2 border-b border-[#e3e7f2] bg-white px-4 py-3 md:px-6"
    >
      <TeamSwitcher />
    </header>
  );
}
